import {Skeleton} from "@mui/material"
import React from "react"
import PropTypes from "prop-types"

const SkeletonInputField = ({key}) => {
    return (
        <Skeleton variant="rectangular" key={key} width="100%" height={56} sx={{ borderRadius: 1 }} />
    )
}

SkeletonInputField.propTypes = {
    key: PropTypes.string
}

export default SkeletonInputField